<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import ThuxGenericComponentFilterMixin from '../../../components/thux-list/ThuxGenericComponentFilterMixin'
import { CommonFilterTypes } from '../store'

export default {
  name: 'ProductCategoryListFilter',
  mixins: [ThuxGenericComponentFilterMixin],
  data () {
    return {
      icon: '',
      itemName: 'product category',
      itemPluralName: 'product categories',
      placeholder: 'Type a product category',
      filterName: 'filter__name__icontains',
      searchLength: 2
    }
  },
  computed: {
    ...mapGetters({
      list: CommonFilterTypes.COMMON_FILTERS.PRODUCT_CATEGORY_COMMON_FILTER.LIST.GETTERS.list
    })
  },
  methods: {
    ...mapMutations({
      setList:
        CommonFilterTypes.COMMON_FILTERS.PRODUCT_CATEGORY_COMMON_FILTER.LIST.MUTATIONS.setList
    }),
    ...mapActions({
      ...CommonFilterTypes.COMMON_FILTERS.PRODUCT_CATEGORY_COMMON_FILTER.LIST.ACTIONS
    }),
    getComponentFilter () {
      this.setList({})
    }
  }
}
</script>
